const invoiceListFilterFields = [
  "invoiceStatus",
  "invoiceSerial",
  "invoiceNumber",
  "buyerLegalName",
  "buyerTaxCode",
  "taxAuthorityCode",
];

const hasFilterValue = (value: any) =>
  value !== null && value !== undefined && value !== "";

export const applyInvoiceListColumnFilters = (
  params: Record<string, any>,
  lazyParams: any,
) => {
  const requestParams = { ...params };

  invoiceListFilterFields.forEach((field) => {
    const value = lazyParams?.filters?.[field]?.value;
    if (!hasFilterValue(value)) {
      return;
    }

    requestParams[field] = Array.isArray(value) ? value.join(",") : value;
  });

  return requestParams;
};
